module.exports = __webpack_public_path__ + "img/46.163941ae.jpg";